
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/progression-bar",
      function () {
        return require("private-next-pages/design-system/progression-bar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/progression-bar"])
      });
    }
  